module.exports = __webpack_public_path__ + "img/hk_address-1.5ebe3e94.png";